import {RulesBuilder} from './rules-builder';

const Factory = {
    getBuilder(dependencies: object): RulesBuilder {
        return new RulesBuilder(dependencies);
    },
};

export {Factory};
